export * from './iconFontAwesomeReligionCross';
export * from './iconFontAwesomeReligionPlaceOfWorship';
export * from './iconFontAwesomeReligionChurch';
export * from './iconFontAwesomeReligionGopuram';
export * from './iconFontAwesomeReligionYinYang';
export * from './iconFontAwesomeReligionVihara';
export * from './iconFontAwesomeReligionToriiGate';
export * from './iconFontAwesomeReligionSynagogue';
export * from './iconFontAwesomeReligionStarOfDavid';
export * from './iconFontAwesomeReligionStarAndCrescent';
export * from './iconFontAwesomeReligionSpaghettiMonsterFlying';
export * from './iconFontAwesomeReligionScrollTorah';
export * from './iconFontAwesomeReligionPersonPraying';
export * from './iconFontAwesomeReligionPeace';
export * from './iconFontAwesomeReligionOm';
export * from './iconFontAwesomeReligionMosque';
export * from './iconFontAwesomeReligionMenorah';
export * from './iconFontAwesomeReligionKhanda';
export * from './iconFontAwesomeReligionKaaba';
export * from './iconFontAwesomeReligionJedi';
export * from './iconFontAwesomeReligionHanukiah';
export * from './iconFontAwesomeReligionHandsPraying';
export * from './iconFontAwesomeReligionHamsa';
export * from './iconFontAwesomeReligionDove';
export * from './iconFontAwesomeReligionDharmachakra';
export * from './iconFontAwesomeReligionBookTanakh';
export * from './iconFontAwesomeReligionBookQuran';
export * from './iconFontAwesomeReligionBookJournalWhills';
export * from './iconFontAwesomeReligionBookBible';
export * from './iconFontAwesomeReligionBahai';
export * from './iconFontAwesomeReligionAtom';
export * from './iconFontAwesomeReligionAnkh';
